export default "__VITE_ASSET__Cnb297gE__"